var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_51",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m67.77,52.05l-1.63,31.44c-.12,2.52-2.2,4.5-4.73,4.5h-22.89c-2.53,0-4.61-1.98-4.73-4.5l-1.64-31.44c-.19-4.08,1.39-8.04,4.34-10.87l8.72-8.35V12.44c0-.55.44-1,1-1h7.51c.55,0,1,.45,1,1v20.39l8.72,8.35c2.95,2.83,4.53,6.79,4.33,10.87Z",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "54.72", y1: "17.995", x2: "45.21", y2: "17.995" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }